export enum SvgIcons {
    FB = 'fb',
    TG = 'tg',
    MAIL = 'mail',
    USER = 'user',
    FINANCE = 'finance',
    MESSAGE = 'message',
    SEARCH = 'search',
    DELETE = 'delete',
    PLUS = 'plus',
    CLOSE = 'close',
    CHEVRON_BOTTOM = 'chevron-bottom',
    INFO = 'info',
    SETTINGS = 'settings',
    SAVE = 'save',
    EDIT_USERS = 'edit-user',
    COPY = 'copy',
    DOTS_VERTICAL = 'dots-vertical',
    DOWNLOAD = 'download',
    EXIT = 'exit',
    WINDOW = 'window',
    VISIBILITY = 'visibility',
    VISIBILITY_OFF = 'visibility-off',
    UPDATE = 'update',
    API = 'api',
    BELL = 'bell',
    MENU = 'menu'
}
